import Paper from "@mui/material/Paper";
import * as React from "react";
import {useEffect, useRef, useState} from "react";
import {limit} from "../../util/StringUtils";
import Button from "@mui/material/Button";
import {Add, ArrowBackIos, ArrowForwardIos, Autorenew, Check, Delete, Edit, KeyboardArrowDown, PlayArrowOutlined, PriorityHigh, WarningAmber} from "@mui/icons-material";
import Typography from "@mui/material/Typography";
import {useNavigate} from "react-router-dom";
import {Accordion, AccordionDetails, AccordionSummary, Autocomplete, Box, Chip, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, Grid2 as Grid, InputLabel, Menu, MenuItem, OutlinedInput, Select, TextField, Tooltip} from "@mui/material";
import userService from "../../services/UserService";
import projectService from "../../services/ProjectService";
import TaskAssignmentDialog from "../dashboard/TaskAssignmentDialog";
import dayjs from 'dayjs';
import {useSnackbar} from "../../util/SnackbarProvider";
import {PRIORITIES, STATUSES} from "../../util/Const";
import calendarNoteService from "../../services/CalendarNoteService";
import parse from "html-react-parser";
import DOMPurify from "dompurify";
import {useTitle} from "../dashboard/TitleContext";
import taskService from "../../services/TaskService";
import {addTimeToDate} from "../../util/DateConverter";
import authService from "../../services/AuthService";

const LOCAL_STORAGE_SEARCH_PARAMS = "project-task-calendar-search-params"
const DEFAULT_SEARCH_PARAMS = {year: new Date().getFullYear(), month: new Date().getMonth() + 1};
let TODAY = new Date()
TODAY.setTime(0)

const ProjectTaskCalendar = () => {

    useTitle([{name: 'Naptár'}])

    const weekDays = Array.from({length: 7}, (_, i) => new Date(1, 0, i).toLocaleDateString('hu-HU', {weekday: 'long'}))
        .map(day => day.substring(0, 1).toUpperCase() + day.substring(1));

    const [weeks, setWeeks] = useState([]);
    const [calendarNotes, setCalendarNotes] = useState([]);
    const [tasks, setTasks] = useState([]);
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useState({...JSON.parse(localStorage.getItem(LOCAL_STORAGE_SEARCH_PARAMS)), year: new Date().getFullYear(), month: new Date().getMonth() + 1})
    const [expanded, setExpanded] = useState(false);
    const taskAssignmentDialog = useRef();
    const {sendAlertMessage} = useSnackbar();
    const [openNewCalendarNoteDialog, setOpenNewCalendarNoteDialog] = useState(false);
    const [context, setContext] = useState()
    const [calendarNotesForToday, setCalendarNotesForToday] = useState([]);
    const [tasksForToday, setTasksForToday] = useState([]);
    const loggedInUser = authService.getCurrentUser();
    const [dayStepper, setDayStepper] = useState(0);

    const handleNewCalendarNoteDialogClose = () => {
        setOpenNewCalendarNoteDialog(false);
        setSelectedUsers([])
    }

    useEffect(() => {
        const updateData = () => {
            TODAY = new Date()
            setWeeks(generateCalendar(searchParams.year, searchParams.month));
            retrieveTasks();
            retrieveTasksForToday();
            retrieveCalendarNotes();
            retrieveCalendarNotesForToday();
        };

        updateData();
        const intervalId = setInterval(updateData, 30 * 1000);
        return () => clearInterval(intervalId);
    }, [searchParams]);

    useEffect(() => {
        retrieveTasksForToday();
        retrieveCalendarNotesForToday();
    }, [dayStepper]);


    const [contextMenu, setContextMenu] = useState(null)
    const handleClose = () => setContextMenu(null)
    const handleContextMenu = (event, day, note) => {
        event.preventDefault();
        setContext({day: day, note: note})
        setSelectedUsers(note?.users || [])
        setContextMenu(contextMenu === null ? {mouseX: event.clientX + 2, mouseY: event.clientY - 6} : null);
    };

    function retrieveCalendarNotesForToday() {
        const date = new Date()
        date.setDate(date.getDate() - dayStepper)
        calendarNoteService.searchForGivenDay({date: date.toLocaleDateString("hu-HU")})
            .then(response => setCalendarNotesForToday(response))
            .catch(error => console.error(error))
    }

    function retrieveTasksForToday() {
        const fromDate = new Date()
        fromDate.setHours(0, 0, 0)
        const toDate = new Date()
        toDate.setHours(23, 59, 59)
        fromDate.setDate(fromDate.getDate() - dayStepper)
        toDate.setDate(toDate.getDate() - dayStepper)
        taskService.search(
            {
                fromDate: addTimeToDate(fromDate),
                toDate: addTimeToDate(toDate)
            })
            .then(response => setTasksForToday(response.content))
            .catch(error => sendAlertMessage(error.message || "Feladatok lekérése sikertelen", "error"));
    }

    function retrieveTasks() {
        taskService.search(buildQueryParams())
            .then(response => setTasks(response.content))
            .catch(error => sendAlertMessage(error.message || "Feladatok lekérése sikertelen", "error"));
    }

    function retrieveCalendarNotes() {
        calendarNoteService.searchWithinMonth({year: searchParams.year, month: searchParams.month})
            .then(response => setCalendarNotes(response))
            .catch(error => sendAlertMessage(error.message || "Bejegyzések lekérése sikertelen", "error"));
    }

    const getMonthRange = (year, month) => {
        const firstDay = new Date(year, month - 1, 1);
        const lastDay = new Date(year, month, 0);

        const localFirstDay = new Date(firstDay.getFullYear(), firstDay.getMonth(), 1);
        const localLastDay = new Date(lastDay.getFullYear(), lastDay.getMonth() + 1, 1);

        return {
            fromDate: addTimeToDate(localFirstDay),
            toDate: addTimeToDate(localLastDay)
        };
    };

    function buildQueryParams() {
        return {
            size: 100,
            ...getMonthRange(searchParams.year, searchParams.month, true),
            ...(searchParams.user && {userIds: searchParams.user.id}),
            ...(searchParams.project && {projectId: searchParams.project.id}),
            ...(searchParams.status && {statuses: searchParams.status}),
            ...(searchParams.priority && {priorities: searchParams.priority}),
        }
    }

    const [users, setUsers] = React.useState([]);
    useEffect(() => {
        userService.getSelectors()
            .then(response => setUsers(response))
            .catch(error => console.error(error))
    }, []);


    useEffect(() => {
        retrieveAssignedTasksForToday()
    }, []);

    const [assignedTasksForToday, setAssignedTasksForToday] = React.useState([]);

    function retrieveAssignedTasksForToday() {
        taskService.search({userIds: loggedInUser.userId, withoutProjectTask: true, statuses: ['NOT_STARTED', 'IN_PROGRESS']})
            .then(response => setAssignedTasksForToday(response.content))
            .catch(error => sendAlertMessage(error.message || "Feladatok lekérése sikertelen", "error"));
    }

    const [projects, setProjects] = React.useState([]);
    useEffect(() => {
        projectService.getSelectors()
            .then(response => setProjects(response))
            .catch(error => console.error(error))
    }, []);

    const handleExtension = () => {
        setExpanded(!expanded);
    };

    const onSearchParamsChange = (name, value) => {
        setSearchParams((prevSearchParams) => ({
            ...prevSearchParams,
            [name]: value
        }))
    }

    const clear = () => {
        setSearchParams(DEFAULT_SEARCH_PARAMS)
    }

    useEffect(() => {
        if (searchParams) localStorage.setItem(LOCAL_STORAGE_SEARCH_PARAMS, JSON.stringify(searchParams));
        else localStorage.removeItem(LOCAL_STORAGE_SEARCH_PARAMS)
    }, [searchParams]);

    const decreaseMonth = () => {
        if (searchParams.month === 1) {
            setSearchParams(prev => ({
                ...prev,
                month: 12,
                year: prev.year - 1
            }))
        } else setSearchParams(prev => ({
            ...prev,
            month: prev.month - 1
        }))
    }

    const increaseMonth = () => {
        if (searchParams.month === 12) {
            setSearchParams(prev => ({
                ...prev,
                month: 1,
                year: prev.year + 1
            }))
        } else setSearchParams(prev => ({
            ...prev,
            month: prev.month + 1
        }))
    }

    const addNewTask = (day) => {
        if (!day) return
        taskAssignmentDialog.current.openDialog({
            scheduleDateStart: dayjs(new Date(searchParams.year, searchParams.month - 1, day, 8, 0, 0)),
            scheduleDateEnd: dayjs(new Date(searchParams.year, searchParams.month - 1, day, 17, 0, 0))
        }, () => {
            retrieveTasks()
            retrieveTasksForToday()
        })
    }

    const monthChangeButtonStyle = {
        margin: "10px",
        minWidth: "50px",
        padding: "0px",
        minHeight: "30px",
        marginTop: "-8px",
        height: "50px",
        backgroundColor: "white"
    };

    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: 48 * 4.5 + 8,
                width: 250
            },
        },
    };

    const [selectedUsers, setSelectedUsers] = useState([]);
    const onUsersChange = (event) => {
        const {value} = event.target
        const newSelection = typeof value === 'string' ? value.split(',') : value;
        const uniqueSelection = newSelection.reduce((acc, user) => {
            const exists = acc.find(item => item.id === user.id);
            if (exists) return acc.filter(item => item.id !== user.id);
            else return [...acc, user];
        }, []);

        setSelectedUsers(uniqueSelection || []);
    };

    function getStyles(name) {
        if (selectedUsers == null || selectedUsers.map(user => user.name).indexOf(name) === -1) return
        return {
            backgroundColor: "#2e7d32",
            color: "white"
        };
    }

    function extractTimeFromDateTime(dateString) {
        if (dateString == null) return null;
        const date = new Date(dateString);
        const hours = date.getHours().toString().padStart(2, "0");
        const minutes = date.getMinutes().toString().padStart(2, "0");
        if (hours === '00' && minutes === '00') return null;
        return `${hours}:${minutes}`;
    }

    function renderCalendarNote(note, index, day) {
        return (
            <div key={index} onContextMenu={(e) => {
                e.stopPropagation()
                e.preventDefault()
                if (day) handleContextMenu(e, day, note)
            }} onClick={(e) => e.stopPropagation()} style={{
                backgroundImage: "linear-gradient(to bottom right, rgb(255, 255, 197) 50%, rgb(255, 255, 80) 100%)",
                boxShadow: "0px 3px 6px rgba(0, 0, 0, 0.3)",
                color: "black",
                marginBottom: "10px",
                marginTop: "5px",
                fontSize: "12px",
                padding: "0px 8px",
                borderRadius: "3px",
                position: "relative"
            }}>
                <div style={{
                    position: "absolute",
                    top: '0',
                    left: '0',
                    color: "black",
                    zIndex: "10",
                    backgroundColor: "gold",
                    borderRadius: "0px 0px 8px 0px",
                    width: "48px",
                    fontSize: "12px"
                }}>{note.targetTime}</div>
                <div className={"cursive-font"} style={{fontSize: "16px", fontWeight: "bold", paddingTop: (note.targetTime ? "16px" : "")}}>
                    {parse(DOMPurify.sanitize(limit(note.noteText || "", 100).replace(/\n/g, '<br/>')))}
                </div>
            </div>
        )
    }

    function renderTask(task, index, day, showTime) {
        const currentDate = new Date(searchParams.year, searchParams.month - 1, day)
        let startTime = extractTimeFromDateTime(task.scheduleDateStart);
        let endTime = extractTimeFromDateTime(task.scheduleDateEnd);
        return (
            <div key={index}
                 onClick={() => navigate(`/dashboard/tasks/${task.id}`)}
                 style={{
                     backgroundColor: task.projectName ? "rgba(255,239,205,0.7)" : "#333",
                     color: task.projectName ? "black" : "white",
                     boxShadow: "0px 3px 6px rgba(0, 0, 0, 0.3)",
                     margin: "4px 0px 0px 0px",
                     marginBottom: showTime ? "10px" : "0px",
                     borderRadius: "10px",
                     fontSize: "12px",
                     padding: "0px 0px",
                     cursor: "pointer",
                     position: "relative",
                     textAlign: 'center'
                 }}>
                <div style={{position: "absolute", left: 0, top: 0, display: "flex", justifyContent: "space-between"}}>
                    <span style={{maxWidth: "20px", maxHeight: "20px"}}>
                        {task.status === 'NOT_STARTED' && <Tooltip title={STATUSES[task.status]}><PlayArrowOutlined style={{color: "white", margin: "0px", fontSize: "20px"}}/></Tooltip>}
                        {task.status === 'IN_PROGRESS' && <Tooltip title={STATUSES[task.status]}><Autorenew style={{color: "white", margin: "0px", fontSize: "20px"}}/></Tooltip>}
                        {task.status === 'DONE' && <Tooltip title={STATUSES[task.status]}><Check style={{color: "white", margin: "0px", fontSize: "20px"}}/></Tooltip>}
                    </span>
                </div>
                {showTime && task.scheduleDateStart &&
                    <div style={{
                        position: "absolute",
                        top: '0',
                        left: '0',
                        color: "black",
                        zIndex: "10",
                        backgroundColor: "gold",
                        borderRadius: "8px 0px 8px 0px",
                        width: "48px",
                        fontSize: "12px"
                    }}>{startTime} </div>}
                {showTime && task.scheduleDateEnd &&
                    <div style={{
                        position: "absolute",
                        top: '0',
                        right: '0',
                        color: "black",
                        zIndex: "10",
                        backgroundColor: "gold",
                        borderRadius: "0px 8px 0px 8px",
                        width: "48px",
                        fontSize: "12px"
                    }}>{endTime}</div>}
                {task.priority === 'IMPORTANT' && <div style={{position: "absolute", right: "0", top: "calc(50% - 12px)"}}>
                    <Tooltip title={PRIORITIES[task.priority]}>
                        <PriorityHigh color={"error"} sx={{marginRight: "-5px"}}/>
                    </Tooltip>
                </div>}
                {task.priority === 'EXTRA_IMPORTANT' && <div style={{position: "absolute", right: "0", top: "calc(50% - 12px)"}}>
                    <Tooltip title={PRIORITIES[task.priority]}>
                        <PriorityHigh color={"error"} sx={{marginRight: "-30px"}}/>
                        <PriorityHigh color={"error"}/>
                    </Tooltip>
                </div>}
                <div
                    style={{
                        fontWeight: task.projectName ? "bold" : "normal",
                        padding: (showTime && (startTime || endTime)) ? "0px 48px" : "0px 24px",
                        backgroundColor: task.projectName ? (task.color || "pink") : null,
                        color: task.projectName ? (isDark(task.color) ? "white" : "black") : "white",
                        borderRadius: "10px 10px 0px 0px",
                        minHeight: "30px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}
                >
                    <div>{task.projectName || task.description}</div>
                </div>

                {task.projectName && <div style={{padding: "0px 12px"}}>{limit(task.description, showTime ? 100 : 24) || "Nincs leírás"}</div>}
                {task.projectName ? <div style={{padding: "0px", fontStyle: "italic"}}>({abbreviateNames(task.users) || "Nincs dolgozó megadva"})</div> : ""}
                <div style={{display: "flex", justifyContent: "space-between", marginLeft: "0px"}}>
                        <span style={{backgroundColor: "#333", borderRadius: "0px 10px 0px 10px"}}>
                            {isSameDate(new Date(task.deadline), currentDate) && <Tooltip title="Határidő">
                                <WarningAmber style={{color: "yellow", margin: "3px 3px 0px 3px", fontSize: "16px"}}/>
                            </Tooltip>}
                        </span>
                    {task.vehicle && <span style={{textAlign: "right", paddingRight: "5px"}}>{task.vehicle}</span>}
                </div>
            </div>
        )
    }

    const tasksWithType = tasksForToday.map(task => ({...task, type: "TASK"}));
    const notesWithType = calendarNotesForToday.map(note => ({...note, type: "NOTE"}));
    const mergedList = [...tasksWithType, ...notesWithType]
        .slice()
        .sort((a, b) => {
            const timeA = a.type === 'TASK' ? new Date(a.scheduleDateStart) : new Date(a.targetDate + " " + a.targetTime);
            const timeB = b.type === 'TASK' ? new Date(b.scheduleDateStart) : new Date(b.targetDate + " " + b.targetTime);
            return timeA.getHours() - timeB.getHours() || timeA.getMinutes() - timeB.getMinutes();
        });

    function isSameDate(date1, date2) {
        return date1.getFullYear() === date2.getFullYear() &&
            date1.getMonth() === date2.getMonth() &&
            date1.getDate() === date2.getDate();
    }

    function isDate1Before2(date1, date2) {
        const d1 = new Date(date1);
        d1.setHours(0, 0, 0, 0);
        const d2 = new Date(date2);
        d2.setHours(0, 0, 0, 0);
        return d1 <= d2;
    }

    function abbreviateNames(names) {
        if (!names) return null;
        const doubleLetters = ["Cs", "Dz", "Gy", "Ly", "Ny", "Sz", "Ty", "Zs"];
        return names.split(", ")
            .map(name => {
                let parts = name.split(" ");
                if (parts.length > 1) {
                    let lastName = parts[1];
                    let abbreviation = doubleLetters.some(dl => lastName.startsWith(dl)) ? lastName.slice(0, 2) : lastName[0]
                    return `${parts[0]} ${abbreviation}`;
                }
                return parts[0];
            })
            .join(", ");
    }

    return (
        <>
            <Grid container columns={20} columnSpacing={2} rowSpacing={2}>
                <Grid size={{xs: 20, md: 20, lg: 4}}>
                    <Paper sx={{borderRadius: "10px", minHeight: "calc(100vh - 104px)", backgroundColor: "rgb(255,255, 220)"}}>
                        <div style={{position: "relative", minHeight: "calc(100vh - 104px)", display: "flex", flexDirection: "column"}}>
                            <Typography sx={{backgroundColor: "darkgray", padding: "5px", textAlign: "center", fontWeight: "bold", borderRadius: "10px 10px 0px 0px", display: "inline-flex", justifyContent: "space-between"}}>
                                <ArrowBackIos onClick={() => setDayStepper(dayStepper + 1)} sx={{cursor: "pointer"}}/>
                                <span style={{cursor: "pointer"}} onClick={() => setDayStepper(0)}>{
                                    (() => {
                                        const date = new Date();
                                        date.setDate(date.getDate() - dayStepper);
                                        return date.toLocaleDateString("hu-HU");
                                    })()
                                }</span>
                                <ArrowForwardIos onClick={() => setDayStepper(dayStepper - 1)} sx={{cursor: "pointer"}}/>
                            </Typography>
                            <div style={{padding: "3px", textAlign: "center", overflowY: "scroll", overflowX: "hidden", flex: 1, minHeight: 0}}>
                                {mergedList.map((item, index) => item.type === "TASK"
                                    ? renderTask(item, index, TODAY.getDate(), true)
                                    : renderCalendarNote(item, index)
                                )}
                            </div>
                            <div style={{width: "100%"}}>
                                <div style={{textAlign: "center", backgroundColor: "darkgray", fontWeight: "bold"}}>Egyéb Feladataim</div>
                                {assignedTasksForToday.map((task, index) => (
                                    <div key={index} style={{margin: "3px"}}>{renderTask(task, index, null)}</div>
                                ))}
                            </div>
                        </div>
                    </Paper>
                </Grid>
                <Grid size={{xs: 20, md: 20, lg: 16}}>
                    <Accordion style={{marginBottom: "10px"}} disableGutters expanded={expanded} onChange={() => handleExtension()}>
                        <AccordionSummary
                            expandIcon={<KeyboardArrowDown sx={{marginRight: "0px", height: "2em", width: "auto"}}/>} sx={{
                            minHeight: "0px",
                            fontSize: "24px",
                            fontWeight: "bold",
                            backgroundColor: "darkgray",
                            borderRadius: "4px 4px 0px 0px",
                            paddingLeft: "20px",
                            margin: "0"
                        }}>
                            Keresési Feltételek
                        </AccordionSummary>
                        <AccordionDetails className="filter-panel">
                            <Grid container columns={20} columnSpacing={{xs: 1}} rowSpacing={{xs: 1}} padding={"10px"}>
                                <Grid size={{lg: 4, md: 10, xs: 30}}>
                                    <Autocomplete
                                        value={(searchParams && searchParams.user) || ""}
                                        margin="normal"
                                        id="user"
                                        onChange={(event, newValue) => onSearchParamsChange("user", newValue)}
                                        options={users}
                                        getOptionLabel={(user) => user.name || ""}
                                        renderInput={(params) => (
                                            <TextField {...params} label="Munkavállaló"/>
                                        )}
                                    />
                                </Grid>

                                <Grid size={{lg: 4, md: 10, xs: 30}}>
                                    <Autocomplete
                                        value={(searchParams && searchParams.project) || ""}
                                        margin="normal"
                                        id="project"
                                        onChange={(event, newValue) => onSearchParamsChange("project", newValue)}
                                        options={projects}
                                        getOptionLabel={(project) => project.name || ""}
                                        renderInput={(params) => (
                                            <TextField {...params} label="Projekt"/>
                                        )}
                                    />
                                </Grid>

                                <Grid size={{lg: 4, md: 10, xs: 30}}>
                                    <FormControl sx={{marginLeft: "0px", marginTop: "0px"}} fullWidth>
                                        <InputLabel id="project-status-label">Státusz</InputLabel>
                                        <Select
                                            variant="outlined"
                                            fullWidth
                                            labelId="project-status-label"
                                            label="Státusz"
                                            value={(searchParams && searchParams.status) || ""}
                                            onChange={(event) => onSearchParamsChange("status", event.target.value)}
                                            sx={{padding: "0px"}}
                                        >
                                            <MenuItem value={null}>Összes</MenuItem>
                                            <MenuItem value={"NOT_STARTED"}>Nincs elkezdve</MenuItem>
                                            <MenuItem value={"IN_PROGRESS"}>Folyamatban</MenuItem>
                                            <MenuItem value={"DONE"}>Befejezve</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>

                                <Grid size={{lg: 4, md: 10, xs: 30}}>
                                    <FormControl sx={{marginLeft: "0px", marginTop: "0px"}} fullWidth>
                                        <InputLabel id="project-priority-label">Prioritás</InputLabel>
                                        <Select
                                            variant="outlined"
                                            fullWidth
                                            labelId="project-priority-label"
                                            name="projectPriority"
                                            label="Prioritás"
                                            value={(searchParams && searchParams.priority) || ""}
                                            onChange={(event) => onSearchParamsChange("priority", event.target.value)}
                                            sx={{textAlign: "left"}}
                                        >
                                            <MenuItem value={null}>Összes</MenuItem>
                                            <MenuItem value={"EXTRA_IMPORTANT"}>Extra fontos</MenuItem>
                                            <MenuItem value={"IMPORTANT"}>Fontos</MenuItem>
                                            <MenuItem value={"NORMAL"}>Normál</MenuItem>
                                            <MenuItem value={"NOT_IMPORTANT"}>Nem fontos</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>

                                <Grid size={{lg: 4, md: 10, xs: 30}}>
                                    <Button onClick={clear} variant="contained" fullWidth style={{height: "56px", margin: "0px"}}>Szűrők Törlése</Button>
                                </Grid>

                            </Grid>
                        </AccordionDetails>
                    </Accordion>
                    <Paper sx={{textAlign: "center", marginBottom: "10px"}}>
                        <Button onClick={() => decreaseMonth()} variant="text" sx={monthChangeButtonStyle}>
                            <ArrowBackIos sx={{marginLeft: "10px", marginRight: "-5px", fontSize: "40px"}}/>
                        </Button>
                        <Typography sx={{
                            fontSize: "36px",
                            marginTop: "10px",
                            display: "inline-block",
                            fontWeight: "bold",
                            width: "350px"
                        }}>{searchParams.year}. {getMonthName(searchParams.month)}</Typography>

                        <Button onClick={() => increaseMonth()} variant="text" sx={monthChangeButtonStyle}>
                            <ArrowForwardIos sx={{fontSize: "40px"}}/>
                        </Button>
                    </Paper>
                    <Paper sx={{marginBottom: "10px"}}>
                        <table style={{
                            width: '100%',
                            height: '100%',
                            tableLayout: 'fixed',
                            borderCollapse: 'collapse',
                            border: '0px solid black'
                        }}>
                            <thead>
                            <tr>
                                {weekDays.map((day, index) => (
                                    <td key={index} style={{
                                        textAlign: 'center',
                                        border: '2px solid black',
                                        backgroundColor: "gray",
                                        color: "white"
                                    }}>{day}</td>
                                ))}
                            </tr>
                            </thead>
                            <tbody>
                            {weeks.map((week, weekIndex) => (
                                <tr key={weekIndex} style={{height: '80px'}}>
                                    {week.map((day, dayIndex) => {
                                            const currentDate = new Date(searchParams.year, searchParams.month - 1, day)
                                            const isToday = isSameDate(TODAY, currentDate)
                                            if (day == null) return <td key={dayIndex} style={{border: '2px solid #ddd'}}></td>
                                            return (
                                                <td key={dayIndex} style={{
                                                    textAlign: "center",
                                                    padding: '5px 8px',
                                                    border: (isToday ? '4px ridge #666' : '2px solid #ddd'),
                                                    backgroundColor: (isToday ? "#ccc" : dayIndex === 5 || dayIndex === 6 ? "#eee" : ""),
                                                    position: "relative",
                                                    verticalAlign: "top"
                                                }} onContextMenu={(e) => handleContextMenu(e, day)} onClick={() => addNewTask(day)}>
                                                    <div style={{
                                                        position: "absolute",
                                                        top: '0',
                                                        left: '0',
                                                        color: "white",
                                                        zIndex: "10",
                                                        backgroundColor: "#999",
                                                        borderRadius: "0px 0px 8px 0px",
                                                        width: "30px",
                                                        fontSize: "16px"
                                                    }}>{day}</div>
                                                    <div style={{height: "18px"}}></div>
                                                    {(() => {
                                                        const taskWithType = tasks.filter(task => (!task.scheduleDateEnd && isSameDate(new Date(task.scheduleDateStart), currentDate))
                                                            || (!task.scheduleDateStart && isSameDate(new Date(task.scheduleDateEnd), currentDate))
                                                            || (task.scheduleDateStart && task.scheduleDateEnd && isDate1Before2(new Date(task.scheduleDateStart), currentDate) && isDate1Before2(currentDate, new Date(task.scheduleDateEnd)))
                                                            || (task.deadline && isSameDate(new Date(task.deadline), currentDate)))
                                                            .map(task => ({...task, type: "TASK"}));
                                                        const notesWithType = calendarNotes.filter(note => (isSameDate(new Date(note.targetDate), currentDate))
                                                            || (note.repetitionType === 'EVERY_WEEK' && new Date(note.targetDate).getDay() === new Date(searchParams?.year, searchParams?.month - 1, day).getDay())
                                                            || (note.repetitionType === 'EVERY_MONTH' && new Date(note.targetDate).getDate() === new Date(searchParams?.year, searchParams?.month - 1, day).getDate()))
                                                            .map(note => ({...note, type: "NOTE"}));
                                                        const mergedList = [...taskWithType, ...notesWithType]
                                                            .slice()
                                                            .sort((a, b) => {
                                                                const getTime = (item) => {
                                                                    switch (item.type) {
                                                                        case 'TASK':
                                                                            return new Date(item.scheduleDateStart);
                                                                        case 'NOTE':
                                                                            return new Date(item.targetDate + " " + item.targetTime);
                                                                        default:
                                                                            return new Date();
                                                                    }
                                                                };
                                                                const timeA = getTime(a);
                                                                const timeB = getTime(b);
                                                                return timeA.getHours() - timeB.getHours() || timeA.getMinutes() - timeB.getMinutes();
                                                            })

                                                        return mergedList.map((item, index) => item.type === "TASK"
                                                            ? renderTask(item, index, day, true)
                                                            : renderCalendarNote(item, index, day))
                                                    })()}
                                                </td>)
                                        }
                                    )}
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </Paper>
                    <TaskAssignmentDialog ref={taskAssignmentDialog}/>

                    <Menu
                        open={contextMenu !== null}
                        onClose={handleClose}
                        anchorReference="anchorPosition"
                        anchorPosition={contextMenu !== null ? {top: contextMenu.mouseY, left: contextMenu.mouseX} : undefined}
                    >
                        <MenuItem onClick={() => {
                            addNewTask(context.day)
                            handleClose()
                        }}><Add sx={{fontSize: "20px", color: "gray", marginRight: "10px"}}/>Új Feladat</MenuItem>
                        <MenuItem onClick={() => {
                            setOpenNewCalendarNoteDialog(true)
                            handleClose()
                        }}><Add sx={{fontSize: "20px", color: "gray", marginRight: "10px"}}/>Új Bejegyzés</MenuItem>
                        {context?.note?.id &&
                            <>
                                <MenuItem onClick={() => {
                                    setOpenNewCalendarNoteDialog(true)
                                    handleClose()
                                }}><Edit sx={{fontSize: "20px", color: "gray", marginRight: "10px"}}/>Bejegyzés Szerkesztése</MenuItem>
                                <MenuItem onClick={() => {
                                    calendarNoteService.delete(context.note.id)
                                        .then(() => {
                                            retrieveCalendarNotes()
                                            retrieveCalendarNotesForToday()
                                        })
                                        .catch(error => sendAlertMessage(error?.message || "Bejegyzés törlése sikertelen", 'error'))
                                        .finally(() => handleClose())
                                }}><Delete sx={{fontSize: "20px", color: "gray", marginRight: "10px"}}/>Bejegyzés törlése</MenuItem>
                            </>
                        }
                    </Menu>

                    <Dialog
                        open={openNewCalendarNoteDialog}
                        onClose={handleNewCalendarNoteDialogClose}
                        PaperProps={{
                            component: 'form',
                            onSubmit: (event) => {
                                event.preventDefault();
                                const formData = new FormData(event.currentTarget);
                                const formJson = Object.fromEntries((formData).entries());
                                formJson.targetDate = new Date(searchParams.year, searchParams.month - 1, context.day + 1).toISOString().split('T')[0];
                                formJson.userIds = selectedUsers.map(u => u.id)
                                if (context?.note?.id) {
                                    calendarNoteService.update(context.note.id, formJson)
                                        .then(() => {
                                            retrieveCalendarNotes()
                                            retrieveCalendarNotesForToday()
                                        })
                                        .catch(error => sendAlertMessage(error?.message || "Bejegyzés módosítása sikertelen", 'error'))
                                } else {
                                    calendarNoteService.create(formJson)
                                        .then(() => {
                                            retrieveCalendarNotes()
                                            retrieveCalendarNotesForToday()
                                        })
                                        .catch(error => sendAlertMessage(error?.message || "Bejegyzés létrehozása sikertelen", 'error'))
                                }
                                handleNewCalendarNoteDialogClose();
                            },
                        }}
                    >
                        <DialogTitle sx={{backgroundColor: "#1976d2", color: "white"}}>Naptár bejegyzés hozzáadása</DialogTitle>
                        <DialogContent sx={{maxWidth: "400px"}}>
                            <TextField
                                autoFocus
                                multiline
                                minRows={3}
                                required
                                margin="dense"
                                name="noteText"
                                defaultValue={context?.note?.noteText}
                                label="Szöveg"
                                fullWidth
                            />
                            <FormControl sx={{marginTop: "16px", marginLeft: "0px"}} fullWidth>
                                <InputLabel id="users-label">Ki lássa még?</InputLabel>
                                <Select
                                    labelId="users-label"
                                    multiple
                                    variant="outlined"
                                    value={selectedUsers || []}
                                    onChange={onUsersChange}
                                    input={<OutlinedInput id="select-multiple-chip" label="Ki lássa még?"/>}
                                    renderValue={(selected) => (
                                        <Box sx={{
                                            display: 'flex',
                                            flexWrap: 'wrap',
                                            gap: 1.0,
                                            margin: "-5px"
                                        }}>
                                            {selected.map((value, index) => (
                                                <Chip key={index} label={value.name}/>
                                            ))}
                                        </Box>
                                    )}
                                    MenuProps={MenuProps}
                                >
                                    {users.map((user, index) => (
                                        <MenuItem
                                            key={index}
                                            value={user}
                                            style={getStyles(user.name)}
                                        >
                                            {user.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                            <FormControl sx={{minWidth: 120, marginTop: "16px", marginLeft: "0px"}} fullWidth>
                                <InputLabel id="repetition-type-label">Ismétlődés Típusa</InputLabel>
                                <Select
                                    variant="outlined"
                                    fullWidth
                                    name="repetitionType"
                                    label="Ismétlődés Típusa"
                                    labelId="repetition-type-label"
                                    sx={{textAlign: "left"}}
                                    defaultValue={context?.note?.repetitionType}
                                >
                                    <MenuItem value={""}>Nincs</MenuItem>
                                    <MenuItem value={"EVERY_WEEK"}>Hetente</MenuItem>
                                    <MenuItem value={"EVERY_MONTH"}>Havonta</MenuItem>
                                </Select>
                            </FormControl>

                            <TextField
                                margin="dense"
                                name="targetTime"
                                label="Időpont"
                                fullWidth
                                type="time"
                                sx={{marginTop: "16px"}}
                                slotProps={{inputLabel: {shrink: true}}}
                                defaultValue={context?.note?.targetTime}
                            />

                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleNewCalendarNoteDialogClose} color="error"
                                    variant="outlined" sx={{marginRight: "auto"}}>Mégse</Button>
                            <Button type="submit" variant="contained">Mentés</Button>
                        </DialogActions>
                    </Dialog>
                </Grid>
            </Grid>
        </>
    );
};

const generateCalendar = (year, month) => {
    let firstDay = new Date(year, month - 1, 1).getDay();
    if (firstDay === 0) firstDay = 7;
    const totalDays = new Date(year, month, 0).getDate();
    const weeks = [[]];
    for (let i = 0; i < firstDay - 1; i++) weeks[0].push(null);
    for (let day = 1; day <= totalDays; day++) {
        if (weeks[weeks.length - 1].length === 7) weeks.push([]);
        weeks[weeks.length - 1].push(day);
    }
    while (weeks[weeks.length - 1].length < 7) weeks[weeks.length - 1].push(null);
    return weeks;
};


function getMonthName(monthNumber) {
    const months = [
        "Január", "Február", "Március", "Április", "Május", "Június",
        "Július", "Augusztus", "Szeptember", "Október", "November", "December"
    ];

    return months[monthNumber - 1] || "Érvénytelen hónap";
}

const isDark = (hex) => {
    if (!hex) return false
    hex = hex.replace("#", "");
    let r = parseInt(hex.substring(0, 2), 16);
    let g = parseInt(hex.substring(2, 4), 16);
    let b = parseInt(hex.substring(4, 6), 16);
    let brightness = r * 0.299 + g * 0.587 + b * 0.114;
    return brightness < 100;
};

export default ProjectTaskCalendar;